/**
 * Service Dependencies
 */
import http from './HttpService'

/**
 * Get the pipeline and associated projects
 *
 * @return {Promise}
 */
export const fetchData = () => {
    return http.get('projects/pipeline/')
}

/**
 * Update a given project's stage
 *
 * @param  {Number} projectId
 * @param  {Number} newStage
 * @return {Promise}
 */
export const updateStage = (projectId, newStage) => {
    return http.patch(`projects/${projectId}/stage/`, {
        id: projectId,
        stage: newStage
    })
}



// WEBPACK FOOTER //
// ./src/services/DealPipelineService.js